<template>
  <div class="avatars-group">
    <p
      v-if="teamName"
      class="avatars-group__title"
    >
      {{ teamName }}
    </p>

    <div
      v-if="team && team.length"
      class="avatars-group__items"
      @click="isTeamDialogShown = true"
    >
      <AppAvatar
        v-for="(member,i) in team"
        :key="member.id"
        :class="{'ml-n4' : i > 0, 'd-none' : i > (usersVisible - 1)}"
        :user="member"
      />
      <AppAvatar
        v-if="team.length > usersVisible"
        class="ml-n4"
        :user="extraUsers"
      />
    </div>

    <div v-else>
      <p class="avatars-group__empty">
        {{ teamNameInGenitive }}
      </p>
    </div>

    <v-dialog
      v-model="isTeamDialogShown"
      width="326"
    >
      <ProjectTeamCard v-bind="teamCardProps" />
    </v-dialog>
  </div>
</template>

<script>
import AppAvatar from '@/components/UI/AppAvatar.vue';
import ProjectTeamCard from '@/components/Projects/ProjectTeamCard.vue';

export default {
  components: {
    AppAvatar,
    ProjectTeamCard,
  },

  props: {
    team: {
      type: Array,
      default: () => [],
    },
    teamName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isTeamDialogShown: false,
      usersVisible: 10,
    };
  },

  computed: {
    teamNameInGenitive() {
      const lastWord = this.teamName.split(' ').pop();
      const genitive = lastWord ? `${lastWord.slice(0, -1)}ego` : '';
      return `Brak zespołu ${genitive}`;
    },

    extraUsers() {
      return {
        firstName: '+',
        lastName: (this.team.length - this.usersVisible).toString(),
      };
    },
    teamCardProps() {
      const props = {
        title: this.teamName,
        users: this.team,
      };
      if (this.teamName.toLowerCase() === 'zespół zlecający') {
        props.emptyStateText = 'Oczekiwanie na dodanie członków zespołu zlecającego.';
      }
      return props;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatars-group {
  cursor:pointer;
  &__title {
    font-size: 10px;
  }
  &__empty {
    line-height: 32px;
    margin: 12px 0;
  }
  &__items {
    height: 56px;
    display: flex;
    align-items: center;
  }
}
</style>
